import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useNavigate } from '@core/js/hooks/navigate';
import { storageService } from '@core/js/services/storage.service';

export const useNavigateToPrevPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const backPageUrl = storageService.session.getItem(['backPageUrl']); /* TotalCasino changes */
    const { prevPath } = location.state || {};

    return useCallback(() => {
        navigate(prevPath || backPageUrl || '/'); /* TotalCasino changes */
    }, [navigate, prevPath, backPageUrl]);
};
